import axios from 'axios';
import * as endpoints from './endpoints';

// ------------------------------------
// Force refresh

export function setupDeviceStream(siteId) {
  return axios.get(`${endpoints.MANAGEMENT}/${siteId}/devices/stream`, endpoints.headers());
}

// ------------------------------------
// Terminals

export function getSimpleTerminals(siteId) {
  return axios.get(`${endpoints.ANALYTICS}/${siteId}/terminals`, endpoints.headers());
}

export function getTerminalsAvailableForProvisioning(siteId, gatewayId, data) {
  return axios.get(`${endpoints.MANAGEMENT}/${siteId}/gateways/${gatewayId}/provisioning`, endpoints.headers(data));
}

export function unlockTerminal(siteId, terminalId, action) {
  return axios.get(`${endpoints.MANAGEMENT}/${siteId}/${terminalId}/${action}`, endpoints.headers());
}

export function updateTerminalsForGateway(siteId, gatewayId, data) {
  return axios.post(`${endpoints.MANAGEMENT}/${siteId}/gateways/${gatewayId}/terminals`, data, endpoints.headers());
}

export function getVkcCardForSite(siteId) {
  return axios.get(`${endpoints.MANAGEMENT}/${siteId}/wkc`, endpoints.headers());
}

export function updateVkcCardForSite(siteId, data) {
  return axios.post(`${endpoints.MANAGEMENT}/${siteId}/wkc`, data, endpoints.headers());
}

export function getMaxAllowedDevicesForSite(siteId) {
  return axios.get(`${endpoints.MANAGEMENT}/${siteId}/maxAllowedDevices`, endpoints.headers());
}

export function updateMaxAllowedDevicesForSite(siteId, data) {
  return axios.post(`${endpoints.MANAGEMENT}/${siteId}/maxAllowedDevices/`, data, endpoints.headers());
}
